import {
  ColumnElement,
  ElementType,
  FieldElement,
  ImageElement,
  LayoutElement,
  SectionElement,
  TableFieldElement,
  TextElement,
} from "@entaconsulting/form";

const newFieldLayoutElement = (): Omit<FieldElement, "name"> => ({
  type: "field",
});

const newTextLayoutElement = (): TextElement => ({
  type: "text",
});

const newImageLayoutElement = (): ImageElement => ({
  type: "image",
  source: "",
});

const newColumnLayoutElement = (): ColumnElement => ({
  type: "column",
  elements: [],
});

const newSectionLayoutElement = (): SectionElement => {
  const columnElement = newColumnLayoutElement();
  columnElement.size = 12;

  return {
    type: "section",
    elements: [columnElement],
  };
};

const newTableLayoutElement = (): Omit<TableFieldElement, "name"> => ({
  type: "field",
  size: 12,
  label: "Table Element",
  canAdd: true,
  canDelete: true,
  listFields: {
    fields: [],
  },
});

export const generateLayoutElement = (
  type: ElementType | "table"
): LayoutElement => {
  const element =
    type === "table"
      ? newTableLayoutElement()
      : type === "section"
      ? newSectionLayoutElement()
      : type === "image"
      ? newImageLayoutElement()
      : type === "text"
      ? newTextLayoutElement()
      : type === "column"
      ? newColumnLayoutElement()
      : newFieldLayoutElement();
  return element;
};
